import styled from 'styled-components';
import { Tabs } from '@/components/Tabs/Tabs';

export const HeaderTabs = styled(Tabs)`
  padding: 10px 15px;
`;
